(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    if (document.body.dataset.cardQuickAddBound) return;
    document.body.dataset.cardQuickAddBound = '1';

    const root = window.Shopify?.routes?.root || '/';

    document.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      if (btn.classList.contains('is-loading')) return;

      const variantId = btn.getAttribute('data-quick-add');
      if (!variantId) return;

      btn.classList.add('is-loading');
      try {
        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', '1');

        const res = await fetch(`${root}cart/add.js`, {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData,
        });
        const data = await res.json().catch(() => null);

        if (!res.ok) {
          const msg = (data && (data.description || data.message)) || (function (l) { return l.indexOf('nl') === 0 ? 'Er liep iets mis. Probeer het opnieuw.' : l.indexOf('de') === 0 ? 'Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal.' : l.indexOf('en') === 0 ? 'Something went wrong. Please try again.' : l.indexOf('es') === 0 ? 'Algo ha fallado. Vuelve a intentarlo.' : l.indexOf('pt') === 0 ? 'Ocorreu um erro. Tente novamente.' : l.indexOf('it') === 0 ? 'Qualcosa è andato storto. Riprova.' : 'Erreur. Réessayez.'; })(document.documentElement.lang || '');
          alert(msg);
          return;
        }

        // Brief visual confirmation
        btn.classList.add('is-added');
        setTimeout(() => btn.classList.remove('is-added'), 1200);

        document.dispatchEvent(new CustomEvent('streetride:cart-added'));
      } catch (err) {
        console.error('[product-card] quick add failed', err);
      } finally {
        btn.classList.remove('is-loading');
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sr-card-pastilles"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__srCardSwBound) return;
    window.__srCardSwBound = true;

    var peutSurvoler = window.matchMedia && window.matchMedia('(hover: hover)').matches;

    function montrer(dot) {
      var box = dot.closest('.sr-card-sw');
      var media = dot.closest('.product-card__media');
      if (!box || !media) return;
      box.querySelectorAll('.sr-card-sw__dot.is-active').forEach(function (d) { d.classList.remove('is-active'); });
      dot.classList.add('is-active');
      var rib = media.querySelector('.sr-pre-ribbon');
      if (rib) rib.hidden = dot.getAttribute('data-pre') !== '1';
      var src = dot.getAttribute('data-src');
      var img = media.querySelector('.product-card__image');
      if (!src || !img) return;
      img.setAttribute('loading', 'eager');
      img.srcset = dot.getAttribute('data-srcset') || '';
      img.src = src;
    }

    document.addEventListener('mouseover', function (e) {
      if (!peutSurvoler) return;
      var dot = e.target.closest && e.target.closest('.sr-card-sw__dot');
      if (dot) montrer(dot);
    });

    document.addEventListener('click', function (e) {
      var dot = e.target.closest && e.target.closest('.sr-card-sw__dot');
      if (dot) {
        e.preventDefault();
        e.stopPropagation();
        if (!peutSurvoler && !dot.classList.contains('is-active')) {
          montrer(dot);
          return;
        }
        var url = dot.getAttribute('data-url');
        if (url) window.location.href = url;
        return;
      }
      var box = e.target.closest && e.target.closest('.sr-card-sw');
      if (box) {
        e.preventDefault();
        e.stopPropagation();
        var actif = box.querySelector('.sr-card-sw__dot.is-active') || box.querySelector('.sr-card-sw__dot');
        if (actif && actif.getAttribute('data-url')) window.location.href = actif.getAttribute('data-url');
      }
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

})();
